import { render, staticRenderFns } from "./Arbo.vue?vue&type=template&id=d3b0c112&scoped=true&"
import script from "./Arbo.vue?vue&type=script&lang=js&"
export * from "./Arbo.vue?vue&type=script&lang=js&"
import style0 from "./Arbo.vue?vue&type=style&index=0&id=d3b0c112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b0c112",
  null
  
)

export default component.exports